import React from "react";
import "./NewAbout.css";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
const About = () => {
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");
    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <section>
      <img
        src={require("../../Assets/bg-vector.png")}
        alt="vector"
        class="bg-vector"
      />
      <div class="about-us">
        <div class="container">
          <div class="abt-sec-wrp style2">
            <div class="row">
              <div class="col-md-6 col-sm-12 col-lg-6">
                <div class="abt-vdo style2 brd-rd5">
                  <img
                    src={require("../../Assets/abt-img2.jpg")}
                    alt="abt-img2.jpg"
                    itemprop="image"
                  />
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-lg-6">
                <div class="abt-desc">
                  <div class="sec-tl">
                    <span class="theme-clr">
                      {rtl ? "تاريخنا" : fr ? "Notre histoire" : "Our History"}
                    </span>
                    <h2 class="headline">
                      {rtl
                        ? "نبذة عن مكة  والمدينة القابضة المحدودة"
                        : fr
                        ? "À PROPOS DE MECQUE & LA MÉDINE HOLDING LTD"
                        : "About MAKKAH & AL MADINAH HOLDING LTD"}
                    </h2>
                    <img src={require("../../Assets/pshape.png")} alt="" />
                  </div>
                  <p class="description">
                    {rtl
                      ? "باعتبارها واحدة من أقدم قصص النجاح وأكثرها شهرة ، تم تشكيل مكة  والمدينة القابضة  من قبل سيدي شهيد ..."
                      : fr
                      ? `MMH est l'une des plus anciennes et des plus célèbres histoires de succès au
                      monde. Elle a été créée par Sidi Shahid...`
                      : "As one of the world’s earliest and most celebrated success stories, MMH Was formed by Sidi Shahid..."}
                  </p>

                  <Link to="/about-us" class="theme-btn theme-bg brd-rd5">
                    {rtl ? "إقرأ المزيد" : fr ? "Lire la suite" : "READ MORE"}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
